export const quickActionHeading ="pages.home.quickActions.quickActionHeading";
export const quickActions = [
    {
      header: "pages.home.quickActions.quickActionsList.newCaseSetup.header",
      body: "pages.home.quickActions.quickActionsList.newCaseSetup.body",
      footer: "pages.home.quickActions.quickActionsList.newCaseSetup.footer",
      link: "/case-setup",
      entityName: 'Case',
    },
    {
      header: "pages.home.quickActions.quickActionsList.applicationAdminSettings.header",
      body: "pages.home.quickActions.quickActionsList.applicationAdminSettings.body",
      footer: "pages.home.quickActions.quickActionsList.applicationAdminSettings.footer",
      link: "/user-management",
      entityName: 'User',
    }
  ];